import * as Tooltip from "@radix-ui/react-tooltip";
import { cn } from "../lib/cn";

export interface ModeBadgeProps {
  label: string;
  hint: string;
  compact?: boolean;
  className?: string;
}

export function ModeBadge({ label, hint, compact = false, className }: ModeBadgeProps) {
  return (
    <Tooltip.Provider delayDuration={200} skipDelayDuration={0}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <button
            type="button"
            aria-label={`${label} mode is on. ${hint}`}
            className={cn(
              "inline-flex min-h-6 items-center gap-1 rounded-full border border-teal-700/30 bg-surface-secondary px-2 py-0.5",
              "font-sans text-xs font-medium text-teal-800",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-700",
              className,
            )}
          >
            <span aria-hidden className="size-1.5 rounded-full bg-teal-700" />
            {compact ? null : label}
          </button>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            side="bottom"
            align="start"
            sideOffset={6}
            collisionPadding={12}
            className={cn(
              "z-50 max-w-64 rounded-lg bg-navy px-3 py-2 text-xs leading-relaxed text-ink-on-brand shadow-lg",
              "motion-safe:data-[state=delayed-open]:animate-in motion-safe:data-[state=delayed-open]:fade-in-0",
            )}
          >
            {hint}
            <Tooltip.Arrow className="fill-ink-primary" />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}
